import {inject, Injectable} from '@angular/core';
import { ActionButton } from 'gung-common';
import { Order, PriceConfigService } from 'gung-standard';
import { JeevesOrderActionConfigService } from 'gung-standard-jeeves';
import { map, Observable, switchMap } from 'rxjs';


// Options hidden when prices are hidden (NOPRICE group or the "Hide price" switch)
const HIDE_PRICE_HIDDEN_BUTTONS = ['XLSX', 'PDF', 'COPY_TO_CART'];


@Injectable({
  providedIn: 'root'
})
export class TyloJeevesOrderActionConfigService extends JeevesOrderActionConfigService {

    protected priceConfigService = inject(PriceConfigService);

    getButtons(item: Order): Observable<ActionButton<Order>[]> {
        return super.getButtons(item).pipe(
        switchMap(buttons =>
            this.priceConfigService.hidePrice.pipe(
                map(hidePrice =>
                    hidePrice
                    ? buttons.filter(b => !HIDE_PRICE_HIDDEN_BUTTONS.includes(b.title))
                    : buttons
                )
            )));
  }

}
